import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAtom, useSetAtom } from 'jotai';
import { ViewContexts , Tabs } from '@store/trends/base/reducer';
import { setViewContext } from '@store/trends/base/actions';
import CompareBuilder from '../drawer/CompareBuilder';
import { viewContextSelector } from '@store/trends/base/selectors';
import FilterBuilder from '../drawer/FilterBuilder';
import { activeTabAtom, modeAtom, TABLE_MODES } from '../atoms';

const Builders = () => {
  const dispatch = useDispatch();
  const viewContext = useSelector(viewContextSelector);
  const [mode, setMode] = useAtom(modeAtom);
  const setActiveTab = useSetAtom(activeTabAtom);

  // switch to trends for add from RT flow
  useEffect(() => {
    if (viewContext === ViewContexts.RT_TRENDS) {
      setMode(TABLE_MODES.filter);
      setActiveTab(Tabs.TopTrends);
    } else if (viewContext === ViewContexts.RT_FILTERS) {
      setMode(TABLE_MODES.compare);
      setActiveTab(Tabs.TopTrends);
    }
    return () => {
      // clear
      dispatch(setViewContext(''));
    };
  }, [viewContext]);

  return (
    <>
      <FilterBuilder />
      <CompareBuilder />
    </>
  );
};

export default Builders;
